(function(){
  // Scroll reveal
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('ff-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.addEventListener('DOMContentLoaded', function(){
      document.querySelectorAll('.ff-reveal').forEach(function(el){
        revealObserver.observe(el);
      });
    });
  }

  // Fly-to-cart animation
  window.ffFlyToCart = function(sourceEl, imageUrl){
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!sourceEl || !cartIcon || !imageUrl) return;

    var startRect = sourceEl.getBoundingClientRect();
    var endRect = cartIcon.getBoundingClientRect();

    var flyer = document.createElement('img');
    flyer.src = imageUrl;
    flyer.className = 'ff-fly-item';
    flyer.style.width = '52px';
    flyer.style.height = '52px';
    flyer.style.left = (startRect.left + startRect.width / 2 - 26) + 'px';
    flyer.style.top = (startRect.top + startRect.height / 2 - 26) + 'px';
    flyer.style.opacity = '1';
    document.body.appendChild(flyer);

    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        var endX = endRect.left + endRect.width / 2 - 26;
        var endY = endRect.top + endRect.height / 2 - 26;
        flyer.style.transform = 'translate(' + (endX - (startRect.left + startRect.width / 2 - 26)) + 'px, ' + (endY - (startRect.top + startRect.height / 2 - 26)) + 'px) scale(0.25) rotate(18deg)';
        flyer.style.opacity = '0.3';
      });
    });

    setTimeout(function(){
      flyer.remove();
      cartIcon.classList.add('ff-cart-pulse');
      setTimeout(function(){ cartIcon.classList.remove('ff-cart-pulse'); }, 550);
    }, 720);
  };

  // Cart celebration: navy paw burst + toast with real free-shipping progress.
  // Runs alongside ffFlyToCart (the flying thumbnail), not as a replacement.
  window.ffShowCartCelebration = function(sourceEl){
    var pawSVG = '<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><ellipse cx="12" cy="15" rx="6.4" ry="5.4"/><ellipse cx="4.5" cy="9" rx="2.4" ry="3.1"/><ellipse cx="19.5" cy="9" rx="2.4" ry="3.1"/><ellipse cx="8.4" cy="4.6" rx="2.1" ry="2.8"/><ellipse cx="15.6" cy="4.6" rx="2.1" ry="2.8"/></svg>';

    var originX, originY;
    if (sourceEl) {
      var rect = sourceEl.getBoundingClientRect();
      originX = rect.left + rect.width / 2;
      originY = rect.top + rect.height / 2;
    } else {
      originX = window.innerWidth / 2;
      originY = window.innerHeight / 2;
    }

    for (var i = 0; i < 8; i++) {
      (function (i) {
        setTimeout(function () {
          var p = document.createElement('div');
          p.className = 'ff-cart-burst-paw';
          p.innerHTML = pawSVG;
          var angle = Math.random() * Math.PI * 2;
          var dist = 35 + Math.random() * 45;
          var x = Math.cos(angle) * dist;
          var y = Math.sin(angle) * dist;
          p.style.setProperty('--end', 'translate(' + x + 'px,' + y + 'px)');
          p.style.setProperty('--rot', (Math.random() * 70 - 35) + 'deg');
          p.style.left = originX + 'px';
          p.style.top = originY + 'px';
          document.body.appendChild(p);
          requestAnimationFrame(function () { p.classList.add('go'); });
          setTimeout(function () { p.remove(); }, 900);
        }, i * 25);
      })(i);
    }

    var toast = document.getElementById('ffCartToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'ffCartToast';
      toast.className = 'ff-cart-toast';
      document.body.appendChild(toast);
    }

    var FREE_SHIP_THRESHOLD = 499;
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var total = cart.total_price / 100;
        var html = '<span class="ff-toast-title">Happiness Added</span>';
        if (total >= FREE_SHIP_THRESHOLD) {
          html += '<span class="ff-toast-sub qualified">Free shipping unlocked!</span>';
        } else {
          var remaining = Math.ceil(FREE_SHIP_THRESHOLD - total);
          html += '<span class="ff-toast-sub">Add \u20b9' + remaining + ' more for free shipping</span>';
        }
        toast.innerHTML = html;
        toast.classList.add('show');
        clearTimeout(toast._hideTimer);
        toast._hideTimer = setTimeout(function () { toast.classList.remove('show'); }, 2600);
      })
      .catch(function () {
        toast.innerHTML = '<span class="ff-toast-title">Happiness Added</span>';
        toast.classList.add('show');
        clearTimeout(toast._hideTimer);
        toast._hideTimer = setTimeout(function () { toast.classList.remove('show'); }, 2200);
      });
  };
})();
